module.exports = __webpack_public_path__ + "assets/img/88ffbcd3b930aea73811935ba2ce81b0.jpg";